import { useEffect, useRef, useState } from 'react';
import { usePageContent } from '@/context/ContentContext';

const translatedReviews = [
  {
    id: 1,
    name: 'Gordana Nedić',
    initial: 'G',
    date: '24. apr. 2026.',
    rating: 5,
    text: 'Kućni Brojevi - Izrada brojeva za kuće, zgrade, firme. Vrlo profesionalni, brzi, efikasni i svaki detalj ispoštovan. Sve preporuke i pohvale!',
    verified: true,
  },
  {
    id: 2,
    name: 'Mika Živković',
    initial: 'M',
    date: '24. apr. 2026.',
    rating: 5,
    text: 'Odličan kvalitet i prelep dizajn. Kućni broj izgleda fantastično na našoj fasadi. Brza isporuka i odlična usluga.',
    verified: true,
  },
  {
    id: 3,
    name: 'Stefan Petrović',
    initial: 'S',
    date: '15. mart. 2026.',
    rating: 5,
    text: 'Savršeno! Pločica za vrata je tačno onakva kakvu sam zamislio. Gravura je precizna i materijal deluje premium. Definitivno ću ponovo naručiti.',
    verified: true,
  },
  {
    id: 4,
    name: 'Ana Milovanović',
    initial: 'A',
    date: '28. feb. 2026.',
    rating: 5,
    text: 'Neverovatan kvalitet i brza dostava. Personalizovani kućni broj je transformisao izgled našeg ulaza. Toplo preporučujem!',
    verified: true,
  },
];

export default function ReviewsSection() {
  const c = usePageContent('home');
  const [currentIndex, setCurrentIndex] = useState(0);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const els = entry.target.querySelectorAll('.reveal');
            els.forEach((el) => el.classList.add('animate-in'));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const nextReview = () => {
    setCurrentIndex((prev) => (prev + 1) % Math.ceil(translatedReviews.length / 2));
  };

  const prevReview = () => {
    setCurrentIndex((prev) => (prev - 1 + Math.ceil(translatedReviews.length / 2)) % Math.ceil(translatedReviews.length / 2));
  };

  const visibleReviews = translatedReviews.slice(currentIndex * 2, currentIndex * 2 + 2);

  return (
    <section ref={sectionRef} className="relative w-full py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Happy%20homeowner%20standing%20at%20modern%20house%20entrance%20showing%20a%20beautiful%20golden%20house%20number%20plate%2C%20warm%20afternoon%20sunlight%2C%20genuine%20smile%2C%20professional%20lifestyle%20photography%20with%20soft%20natural%20lighting%20and%20clean%20background%2C%20customer%20satisfaction%20moment&width=1600&height=900&seq=reviews-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-[1450px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out font-heading text-3xl md:text-4xl font-bold text-white mb-4">
            {c.reviews_heading}
          </h2>
        </div>

        <div className="reveal opacity-0 translate-y-4 transition-all duration-700 delay-200 ease-out relative max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {visibleReviews.map((review) => (
              <div key={review.id} className="bg-white rounded-lg p-6 border border-background-200 shadow-sm">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#4285F4] rounded-full text-white font-label text-sm font-medium">
                    {review.initial}
                  </div>
                  <div>
                    <div className="font-label text-sm font-medium text-foreground-950">{review.name}</div>
                    <div className="text-xs text-foreground-600">{review.date}</div>
                  </div>
                  <div className="ml-auto">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-google-fill text-foreground-600 text-lg" />
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-0.5 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i className={`${i < review.rating ? 'ri-star-fill text-amber-400' : 'ri-star-line text-background-400'} text-sm`} />
                    </div>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{review.text}</p>
                <div className="mt-3 flex items-center gap-2 text-xs text-foreground-600">
                  <i className="ri-shield-check-line text-green-500" />
                  Verifikovan kupac
                </div>
              </div>
            ))}
          </div>

          <div className="flex items-center justify-center gap-3 mt-6">
            <button
              onClick={prevReview}
              className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center border border-white/30 rounded-full text-white/70 hover:border-amber-500 hover:text-amber-400 transition-colors"
            >
              <i className="ri-arrow-left-line text-sm md:text-base" />
            </button>
            <div className="flex items-center gap-2">
              {Array.from({ length: Math.ceil(translatedReviews.length / 2) }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentIndex(i)}
                  className={`w-2 h-2 rounded-full transition-colors ${i === currentIndex ? 'bg-amber-500' : 'bg-white/40'}`}
                />
              ))}
            </div>
            <button
              onClick={nextReview}
              className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center border border-white/30 rounded-full text-white/70 hover:border-amber-500 hover:text-amber-400 transition-colors"
            >
              <i className="ri-arrow-right-line text-sm md:text-base" />
            </button>
          </div>

          <div className="text-center mt-4">
            <a href="#" className="text-sm text-white/70 hover:text-amber-400 transition-colors inline-flex items-center gap-1">
              <i className="ri-google-fill" />
              Pogledaj sve ocene
            </a>
          </div>
        </div>
      </div>

      <style>{`
        .reveal.animate-in {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>
    </section>
  );
}